<template>
	<div class="bettingRecord-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("head.transactiondetails") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<div class="data-time-picker">
			<div style="justify-content: unset;">
				<p style="margin-right:1rem">{{ $t("transactiondetails.type") }}：</p>
				<el-select v-model="value" :placeholder="tips" @change="valueChange">
					<el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div>
				<p>{{ $t("transactiondetails.date") }}：</p>
				<div class="dataPicker" @click="dataPickerShow = true">
					<p v-if="dataPickerRange">{{ dataPickerRange }}</p>
					<p v-else>{{ $t("transactiondetails.select_date") }}</p>
				</div>
				<van-calendar v-model:show="dataPickerShow" type="range" @confirm="onConfirm" :min-date="minDate"
					:max-date="maxDate" allow-same-day />
				<van-button color="#F8C007" @click="getWalletBidFlow" style="background: unset" plain>{{
						$t("transactiondetails.select")
				}}</van-button>
			</div>
		</div>
		<div class="money">
			<p @click="changeMoneyType('USDT')" :class="moneyType == 'USDT' ? 'active' : ''">
				USDT
			</p>
			<p @click="changeMoneyType('TRX')" :class="moneyType == 'TRX' ? 'active' : ''">
				TRX
			</p>
		</div>
		<div class="bettingmoney">
			<div>
				{{ $t("transactiondetails.bettingmoney") }}
			</div>
			<div>
				{{ $t("transactiondetails.winning_amount") }}
			</div>
			<div>
				{{ $t("transactiondetails.time") }}
			</div>
		</div>
		<ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto">
			<div v-if="number.length < 1" style="padding:  3rem 0;color: #ffffff;text-align: center;">
				{{ $t("data.noData") }}
			</div>
			<div v-else class="USDThash" v-for="(item, index) in number" :key="index">
				<div>
					<div class="hashblock">
						<div>{{ $t("withdrawal.betting") }}：{{ item.flowOp == '1' ? '+' : '-' }}{{
								item.number
						}} {{ moneyType }}</div>
						<div style="color:#999999">{{ $t("history.type") }}：{{ matchInfo[item.type] || '--' }}
						</div>
						<div style="color:#999999">{{ $t("phone.pc") }}：+{{
								item.bonus
						}} {{ moneyType }}
						</div>
					</div>
					<div class="type" style="padding-bottom:8px">
						<div style="display:flex" v-if="label == 'A6' || label == 'B3'">{{
								$t("history.block")
						}}hash：<p v-for="(item2, index2) in item.blockhash" :key="index2"
								:class="item2.colorred == true ? 'colorred' : item2.colorblue == true ? 'colorblue' : ''">
								{{ item2.number }}</p>
						</div>
						<div style="display:flex" v-else-if="label == 'A7' || label == 'B4'">
							{{ $t("history.block")
							}}hash：<p v-for="(item2, index2) in item.blockhash" :key="index2"
								:class="index2 == '9' ? 'colorblue' : index2 == '8' ? 'colorblue' : index2 == '6' ? 'colorred' : index2 == '5' ? 'colorred' : ''">
								{{ item2.number }}</p>
						</div>
						<div style="display:flex" v-else>{{ $t("history.block") }}hash：<p
								v-for="(item2, index2) in item.blockhash" :key="index2"
								:class="item2.colorred == true ? 'colorred' : item2.colorblue == true ? 'colorblue' : ''">
								{{ item2.number }}</p>
						</div>

						<div style="display:flex">{{ $t("history.results_of") }}：<p class="colorred">{{
								item.resultValue
						}}</p>
						</div>
					</div>
					<div class="type">
						<div @click="toBlock(item.height)">{{ $t("history.highly") }}：{{ item.height }}</div>
						<div>{{ item.createTime }}</div>
					</div>
				</div>
			</div>
		</ul>
	</div>
</template>

<script>
import {
	walletBidFlow, dealFlow
} from "@/utils/request";
export default {
	data() {
		return {
			moneyType: "USDT",
			number: 10,
			monthValue: "",
			dataPickerShow: false,
			dataPickerRange: "",
			minDate: new Date(2010, 1, 1),
			maxDate: new Date(2050, 12, 31),
			height: '',//屏幕高度
			options: [],
			value: this.$t("transactiondetails.B1"),
			current: 1,
			tips: this.$t("transactiondetails.input_type"),//请选择类型
			matchInfo: {
				B101: this.$t("entertainment.big"),
				B102: this.$t("entertainment.small"),
				B103: this.$t("entertainment.single"),
				B104: this.$t("entertainment.double"),
				B201: this.$t("entertainment.forlarge"),
				B202: this.$t("entertainment.smallsingle"),
				B203: this.$t("entertainment.large_double"),
				B204: this.$t("entertainment.small_double"),
				B301: this.$t("entertainment.dragon"),
				B302: this.$t("entertainment.tiger"),
				B303: this.$t("entertainment.us"),
				B401: this.$t("entertainment.zhuang"),
				B402: this.$t("entertainment.idle"),
				B403: this.$t("entertainment.he"),
				B501: '1',
				B502: '2',
				B503: '3',
				B504: '4',
				B505: '5',
				B506: '6',
				B507: '7',
				B508: '8',
				B509: '9',
				B510: '0',
				A101: this.$t("entertainment.both_sides") + '-' + this.$t("entertainment.big"),
				A102: this.$t("entertainment.both_sides") + '-' + this.$t("entertainment.small"),
				A103: this.$t("entertainment.both_sides") + '-' + this.$t("entertainment.single"),
				A104: this.$t("entertainment.both_sides") + '-' + this.$t("entertainment.double"),
				A110: this.$t("entertainment.champion") + '-1',
				A111: this.$t("entertainment.champion") + '-2',
				A112: this.$t("entertainment.champion") + '-3',
				A113: this.$t("entertainment.champion") + '-4',
				A114: this.$t("entertainment.champion") + '-5',
				A115: this.$t("entertainment.champion") + '-6',
				A116: this.$t("entertainment.champion") + '-7',
				A117: this.$t("entertainment.champion") + '-8',
				A118: this.$t("entertainment.champion") + '-9',
				A119: this.$t("entertainment.champion") + '-10',
				A201: this.$t("entertainment.champion") + '-1',
				A202: this.$t("entertainment.champion") + '-2',
				A203: this.$t("entertainment.champion") + '-3',
				A204: this.$t("entertainment.champion") + '-4',
				A205: this.$t("entertainment.champion") + '-5',
				A206: this.$t("entertainment.champion") + '-6',
				A207: this.$t("entertainment.champion") + '-7',
				A208: this.$t("entertainment.champion") + '-8',
				A209: this.$t("entertainment.champion") + '-9',
				A210: this.$t("entertainment.champion") + '-10',
				A211: this.$t("entertainment.yajun") + '-1',
				A212: this.$t("entertainment.yajun") + '-2',
				A213: this.$t("entertainment.yajun") + '-3',
				A214: this.$t("entertainment.yajun") + '-4',
				A215: this.$t("entertainment.yajun") + '-5',
				A216: this.$t("entertainment.yajun") + '-6',
				A217: this.$t("entertainment.yajun") + '-7',
				A218: this.$t("entertainment.yajun") + '-8',
				A219: this.$t("entertainment.yajun") + '-9',
				A220: this.$t("entertainment.yajun") + '-10',
				A221: this.$t("entertainment.he") + '-3',
				A222: this.$t("entertainment.he") + '-4',
				A223: this.$t("entertainment.he") + '-5',
				A224: this.$t("entertainment.he") + '-6',
				A225: this.$t("entertainment.he") + '-7',
				A226: this.$t("entertainment.he") + '-8',
				A227: this.$t("entertainment.he") + '-9',
				A228: this.$t("entertainment.he") + '-10',
				A229: this.$t("entertainment.he") + '-11',
				A230: this.$t("entertainment.he") + '-12',
				A231: this.$t("entertainment.he") + '-13',
				A232: this.$t("entertainment.he") + '-14',
				A233: this.$t("entertainment.he") + '-15',
				A234: this.$t("entertainment.he") + '-16',
				A235: this.$t("entertainment.he") + '-17',
				A236: this.$t("entertainment.he") + '-18',
				A237: this.$t("entertainment.he") + '-19',
				A301: this.$t("entertainment.champion_one_size") + '-1',
				A302: this.$t("entertainment.champion_one_size") + '-2',
				A303: this.$t("entertainment.champion_one_size") + '-3',
				A304: this.$t("entertainment.champion_one_size") + '-4',
				A305: this.$t("entertainment.champion_one_size") + '-5',
				A306: this.$t("entertainment.champion_one_size") + '-6',
				A307: this.$t("entertainment.champion_one_size") + '-7',
				A308: this.$t("entertainment.champion_one_size") + '-8',
				A309: this.$t("entertainment.champion_one_size") + '-9',
				A310: this.$t("entertainment.champion_one_size") + '-10',
				A311: this.$t("entertainment.crown") + '-' + this.$t("entertainment.andbig"),
				A312: this.$t("entertainment.crown") + '-' + this.$t("entertainment.andsmall"),
				A313: this.$t("entertainment.crown") + '-' + this.$t("entertainment.andsingle"),
				A314: this.$t("entertainment.crown") + '-' + this.$t("entertainment.anddouble"),
				A315: this.$t("entertainment.championtwo") + '-' + this.$t("entertainment.big"),
				A316: this.$t("entertainment.championtwo") + '-' + this.$t("entertainment.small"),
				A317: this.$t("entertainment.championtwo") + '-' + this.$t("entertainment.single"),
				A318: this.$t("entertainment.championtwo") + '-' + this.$t("entertainment.double"),
				A401: this.$t("entertainment.big"),
				A402: this.$t("entertainment.small"),
				A403: this.$t("entertainment.single"),
				A404: this.$t("entertainment.double"),
				A501: this.$t("entertainment.daxiao") + '-' + this.$t("entertainment.forlarge"),
				A502: this.$t("entertainment.daxiao") + '-' + this.$t("entertainment.smallsingle"),
				A503: this.$t("entertainment.daxiao") + '-' + this.$t("entertainment.large_double"),
				A504: this.$t("entertainment.daxiao") + '-' + this.$t("entertainment.small_double"),
				A601: this.$t("entertainment.Long_Huge") + '-' + this.$t("entertainment.dragon"),
				A602: this.$t("entertainment.Long_Huge") + '-' + this.$t("entertainment.tiger"),
				A603: this.$t("entertainment.Long_Huge") + '-' + this.$t("entertainment.us"),
				A701: this.$t("entertainment.baccarat") + '-' + this.$t("entertainment.zhuang"),
				A702: this.$t("entertainment.baccarat") + '-' + this.$t("entertainment.idle"),
				A703: this.$t("entertainment.baccarat") + '-' + this.$t("entertainment.us"),
				A801: this.$t("entertainment.gallbladder") + '1',
				A802: this.$t("entertainment.gallbladder") + '2',
				A803: this.$t("entertainment.gallbladder") + '3',
				A804: this.$t("entertainment.gallbladder") + '4',
				A805: this.$t("entertainment.gallbladder") + '5',
				A806: this.$t("entertainment.gallbladder") + '6',
				A807: this.$t("entertainment.gallbladder") + '7',
				A808: this.$t("entertainment.gallbladder") + '8',
				A809: this.$t("entertainment.gallbladder") + '9',
				A810: this.$t("entertainment.gallbladder") + '10',
			},
			label: ''
		};
	},
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	//获取屏幕高度
	beforeMount() {
		if (this.$route.query.address) {
			this.options = [{
				value: this.$t("transactiondetails.B1"),
				label: "B1",
			},
			{
				value: this.$t("transactiondetails.B2"),
				label: "B2",
			},
			{
				value: this.$t("transactiondetails.B3"),
				label: "B3",
			},
			{
				value: this.$t("transactiondetails.B4"),
				label: "B4",
			},
			{
				value: this.$t("transactiondetails.B5"),
				label: "B5",
			},]
		} else {
			this.options = [{
				value: this.$t("transactiondetails.B1"),
				label: "B1",
			},
			{
				value: this.$t("transactiondetails.B2"),
				label: "B2",
			},
			{
				value: this.$t("transactiondetails.B3"),
				label: "B3",
			},
			{
				value: this.$t("transactiondetails.B4"),
				label: "B4",
			},
			{
				value: this.$t("transactiondetails.B5"),
				label: "B5",
			}, {
				value: this.$t("transactiondetails.A1"),
				label: "A1",
			},
			{
				value: this.$t("transactiondetails.A2"),
				label: "A2",
			},
			{
				value: this.$t("transactiondetails.A3"),
				label: "A3",
			},
			{
				value: this.$t("transactiondetails.A4"),
				label: "A4",
			},
			{
				value: this.$t("transactiondetails.A5"),
				label: "A5",
			}, {
				value: this.$t("transactiondetails.A6"),
				label: "A6",
			},
			{
				value: this.$t("transactiondetails.A7"),
				label: "A7",
			},
			{
				value: this.$t("transactiondetails.A8"),
				label: "A8",
			}]

		}
	},
	mounted() {
		this.getWalletBidFlow()
	},
	methods: {
		valueChange() {
		},
		//钱包下注记录
		getWalletBidFlow() {
			this.number = ''
			this.current = 1
			this.options.map((item) => {
				if (item.value == this.value) {
					if (this.$route.query.address) {
						this.label = item.label
						walletBidFlow({
							coin: this.moneyType,
							type: item.label,
							address: this.$route.query.address,
							current: this.current,
							size: 20,
							time: this.dataPickerRange,
						}).then((res) => {
							if (res.code == "200") {
								res.data.records.map((item, index) => {
									let blockhash = item.blockhash.slice(item.blockhash.length - 10, item.blockhash.length).split('')
									let temp = [
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false },
										{ number: '', colorred: false, colorblue: false }
									]
									for (let i = 0; i < blockhash.length; i++) {
										temp[i].number = blockhash[i]
										temp[i].colorred = false
										temp[i].colorblue = false
									}
									let red = 0
									let blue = 0
									for (let i = blockhash.length - 1; i > 0; i--) {
										if (blockhash[i] == item.resultValue.split(',')[0]) {
											if (red == 0) {
												temp[i].colorred = true
												red = 1
											}
										} else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
											if (red == 0) {
												temp[i].colorred = true
												red = 1
											}
										}
										if (this.label == 'B3' || this.label == 'A6') {
											if (blockhash[i] == item.resultValue.split(',')[1]) {
												if (blue == 0 && temp[i].colorred != true) {
													temp[i].colorblue = true
													blue = 1
												}
											} else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
												if (blue == 0 && temp[i].colorred != true) {
													temp[i].colorblue = true
													blue = 1
												}
											}
										}
									}
									item.blockhash = temp
									if (index == res.data.records.length - 1) {
										this.number = res.data.records
									}
								})
							}
							if (res.code == '403') {
								localStorage.setItem('token', '')
								this.$router.push("/");
							}
						})
					} else {
						setTimeout(() => {
							dealFlow({
								coin: this.moneyType,
								type: item.label,
								current: this.current,
								size: 20,
								time: this.dataPickerRange,
							}).then((res) => {
								if (res.code == "200") {
									this.label = item.label
									res.data.records.map((item, index) => {
										let blockhash = item.blockhash.slice(item.blockhash.length - 10, item.blockhash.length).split('')
										let temp = [
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false }
										]
										for (let i = 0; i < blockhash.length; i++) {
											temp[i].number = blockhash[i]
											temp[i].colorred = false
											temp[i].colorblue = false
										}
										let red = 0
										let blue = 0
										for (let i = blockhash.length - 1; i > 0; i--) {
											if (blockhash[i] == item.resultValue.split(',')[0]) {
												if (red == 0) {
													temp[i].colorred = true
													red = 1
												}
											} else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
												if (red == 0) {
													temp[i].colorred = true
													red = 1
												}
											}
											if (this.label == 'B3' || this.label == 'A6') {
												if (blockhash[i] == item.resultValue.split(',')[1]) {
													if (blue == 0 && temp[i].colorred != true) {
														temp[i].colorblue = true
														blue = 1
													}
												} else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
													if (blue == 0 && temp[i].colorred != true) {
														temp[i].colorblue = true
														blue = 1
													}
												}
											}
										}
										item.blockhash = temp
										if (index == res.data.records.length - 1) {
											this.number = res.data.records
										}
									})
								}
								if (res.code == '403') {
									localStorage.setItem('token', '')
									this.$router.push("/");
								}
							})
						}, 100);
					}
				}
			})

		},
		onConfirm(value) {
			this.dataPickerRange =
				value[0].getFullYear() +
				"-" +
				(value[0].getMonth() + 1) +
				"-" +
				value[0].getDate() +
				" ~ " +
				value[1].getFullYear() +
				"-" +
				(value[1].getMonth() + 1) +
				"-" +
				value[1].getDate();
			this.dataPickerShow = false;
		},
		load() {
			this.options.map((item) => {
				if (item.value == this.value) {
					if (this.$route.query.address) {
						walletBidFlow({
							coin: this.moneyType,
							type: item.label,
							address: this.$route.query.address,
							current: this.current + 1,
							size: 20,
							time: this.dataPickerRange,
						}).then((res) => {
							if (res.code == "200") {
								if (res.data.records.length > 0) {
									this.current += 1
									res.data.records.map((item, index) => {
										let blockhash = item.blockhash.slice(item.blockhash.length - 10, item.blockhash.length).split('')
										let temp = [
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false }
										]
										for (let i = 0; i < blockhash.length; i++) {
											temp[i].number = blockhash[i]
											temp[i].colorred = false
											temp[i].colorblue = false
										}
										let red = 0
										let blue = 0
										for (let i = blockhash.length - 1; i > 0; i--) {
											if (blockhash[i] == item.resultValue.split(',')[0]) {
												if (red == 0) {
													temp[i].colorred = true
													red = 1
												}
											} else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
												if (red == 0) {
													temp[i].colorred = true
													red = 1
												}
											}
											if (this.label == 'B3' || this.label == 'A6') {
												if (blockhash[i] == item.resultValue.split(',')[1]) {
													if (blue == 0 && temp[i].colorred != true) {
														temp[i].colorblue = true
														blue = 1
													}
												} else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
													if (blue == 0 && temp[i].colorred != true) {
														temp[i].colorblue = true
														blue = 1
													}
												}
											}
										}
										item.blockhash = temp
										if (index == res.data.records.length - 1) {
											that.number = [...that.number, ...res.data.records]
										}
									})
								}
							}
						})
					} else {
						dealFlow({
							coin: this.moneyType,
							current: this.current + 1,
							type: item.label,
							size: 20,
							time: this.dataPickerRange,
						}).then((res) => {
							if (res.code == "200") {
								if (res.data.records.length > 0) {
									this.current += 1
									res.data.records.map((item, index) => {
										let blockhash = item.blockhash.slice(item.blockhash.length - 10, item.blockhash.length).split('')
										let temp = [
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false },
											{ number: '', colorred: false, colorblue: false }
										]
										for (let i = 0; i < blockhash.length; i++) {
											temp[i].number = blockhash[i]
											temp[i].colorred = false
											temp[i].colorblue = false
										}
										let red = 0
										let blue = 0
										for (let i = blockhash.length - 1; i > 0; i--) {
											if (blockhash[i] == item.resultValue.split(',')[0]) {
												if (red == 0) {
													temp[i].colorred = true
													red = 1
												}
											} else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
												if (red == 0) {
													temp[i].colorred = true
													red = 1
												}
											}
											if (this.label == 'B3' || this.label == 'A6') {
												if (blockhash[i] == item.resultValue.split(',')[1]) {
													if (blue == 0 && temp[i].colorred != true) {
														temp[i].colorblue = true
														blue = 1
													}
												} else if (blockhash[i] == '0' && item.resultValue.split(',')[0] == '10') {
													if (blue == 0 && temp[i].colorred != true) {
														temp[i].colorblue = true
														blue = 1
													}
												}
											}
										}
										item.blockhash = temp
										if (index == res.data.records.length - 1) {
											that.number = [...that.number, ...res.data.records]
										}
									})
								}
							}
						})
					}
				}
			})

		},
		//选择币种类型
		changeMoneyType(item) {
			this.moneyType = item;
			this.getWalletBidFlow()
		},
		toBack() {
			this.$router.push("/user");
		},
	},
};
</script>
<style>
.el-select-dropdown {
	border: unset;
	background: unset;
	left: 0;
}

.el-select-dropdown__item.selected {
	background: #161414 !important;
}

.el-scrollbar {
	width: 18.75rem;
	background: #161414;
	border: unset;
}
</style>
<style lang="scss" scoped>
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
	width: 12.5rem;
}

.colorred {
	color: #b51717 !important;
}

.colorblue {
	color: #1f49be !important;
}

.USDThash {
	padding: 15px;
	border-bottom: 1px solid #272727;
	margin-top: 5px;

	.hashblock {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;

		div:nth-child(1) {
			font-size: 13px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
			text-align: center;
		}

		div:nth-child(2) {
			font-size: 13px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FF693A;
		}

		div:nth-child(3) {
			font-size: 13px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FF693A;
		}

		.green {
			color: green !important;
			;
		}
	}

	.type {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		div {
			font-size: 12px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #565656;
			padding-bottom: 0.25rem;
		}
	}
}

/deep/ .el-input__inner {
	background: #161414;
	border: unset !important;
	color: #FFFFFF;
}

/deep/ .van-button {
	height: unset;
	padding: 6px 15px;
}

.bettingRecord-user {
	width: 100vw;
	height: var(--height);
	background: #0c0b0b;

	.data-time-picker {
		padding: 0 0.9375rem;

		>div {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 3rem;

			.dataPicker {
				width: 62%;
				background: #161414;
				padding: 6px 0;

				>p {
					font-size: 0.8125rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					padding-left: 1rem;
				}
			}

			>p {
				display: block;
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				height: 1rem;
			}
		}
	}

	.infinite-list {
		height: calc(var(--height) - 15.25rem);
	}

	.bettingmoney {
		display: flex;
		justify-content: space-between;
		padding: 0 0.9375rem;
		height: 2rem;

		div {
			font-size: 0.75rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
			width: 5.625rem;
		}

		div:nth-child(1) {
			text-align: left;
		}

		div:nth-child(2) {
			text-align: center;
		}

		div:nth-child(3) {
			text-align: right;
		}
	}

	.details-lists {
		padding: 0.9375rem 0.9375rem;
		border-bottom: 0.0625rem solid #272727;
		display: flex;
		justify-content: space-between;

		div {
			font-size: 0.75rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
			width: 5.625rem;
		}

		div:nth-child(1) {
			text-align: left;
		}

		div:nth-child(2) {
			text-align: center;
		}

		div:nth-child(3) {
			text-align: right;
		}

		// .item-top {
		// 	// display: flex;
		// 	// justify-content: space-between;
		// 	padding-bottom: 0.5rem;

		// 	>p {
		// 		font-size: 0.8125rem;
		// 		font-family: PingFang SC-Medium, PingFang SC;
		// 		font-weight: 500;
		// 		color: #ffffff;
		// 	}
		// }

		// .item-bottom {
		// 	// display: flex;
		// 	// justify-content: space-between;

		// 	>p {
		// 		font-size: 0.8125rem;
		// 		font-family: PingFang SC-Medium, PingFang SC;
		// 		font-weight: 500;
		// 		color: #999999;
		// 	}
		// }
	}

	.money {
		display: flex;
		justify-content: space-around;
		padding: 1rem 0;

		.active {
			color: #ffc400 !important;
			border-bottom: 0.0625rem solid #ffc400;
		}

		>p {
			font-size: 0.875rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
			padding-bottom: 0.25rem;
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/transactiondetails.vue